import { Link } from "react-router-dom";

const HView = ({
  path,
  name,
  state,
  isNewWindow = false,
}: {
  path: string;
  name: string;
  isNewWindow?: boolean;
  state?: any;
}) => {
  return (
    <Link
      className="text-[#0364FF]"
      to={path}
      state={state}
      target={isNewWindow ? "_blank" : "_self"}
    >
      {name}
    </Link>
  );
};

export default HView;
